import React from 'react';
import { publicPostPath } from '../utils/url/postPath';
import styles from './PublicTopicPosts.module.scss';
import { gql } from '../graphql/generated';
import type { DocumentType } from '../graphql/generated';
import Link from '../utils/router/Link';

const POST_FRAGMENT = gql(`
  fragment PublicTopicPosts_posts on PublicPost {
    id
    ...publicPostPath_post
  }
`);

interface PublicTopicPostsProps {
  posts: DocumentType<typeof POST_FRAGMENT>[];
}

const PublicTopicPosts = ({ posts }: PublicTopicPostsProps) => (
  <div className={styles.container}>
    {posts.map((post) => (
      <Link key={post.id} to={publicPostPath(post)}>
        {post.title}
      </Link>
    ))}
  </div>
);

export default PublicTopicPosts;
